import { FunctionComponent } from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import IconButton from '@mui/material/IconButton';

import useChangePrompt from '../../../hooks/use-change-prompt/use-change-prompt.hook';
import { ExpandIconButtonProps } from './models/expand-icon-button-props.model';

const ExpandIconButton: FunctionComponent<ExpandIconButtonProps> = ({
  onExpandRow,
  currentRowIndex,
  isExpanded,
  changePrompt,
}): JSX.Element => {
  const hookButtonAction = useChangePrompt(
    changePrompt,
    () => onExpandRow(currentRowIndex),
    <span>Warning</span>,
    <span>Filled information will be lost. Leave anyway?</span>
  );

  return (
    <IconButton
      sx={{ padding: '0 8px' }}
      onClick={hookButtonAction}
      disableRipple
    >
      {isExpanded ? (
        <KeyboardArrowUpIcon
          sx={{ color: theme => theme.palette.primary.main }}
        />
      ) : (
        <KeyboardArrowDownIcon
          sx={{ color: theme => theme.palette.primary.main }}
        />
      )}
    </IconButton>
  );
};

export default ExpandIconButton;
